var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-open-help"},[_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('IconHelp',{attrs:{"width":"25px","height":"25px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }